<template>
  <div>
    <v-autocomplete
      v-model="clifor"
      :loading="loading"
      :items="items"
      cache-items
      :search-input.sync="searchClifor"
      no-data-text="Cerca un nominativo per codice o descrizione"
      :placeholder="soloPlaceholder ? item.label : ''"
      :label="soloPlaceholder ? '' : item.label"
      :rules="rulesValidation"
      item-text="testo"
      item-value="id"
      outlined dense
      hide-details="auto"
      :background-color="backColor"
      clearable
      :return-object="true"
      :disabled="disabled || localDisabled"
      @change="onchange"
      v-if="showItem"
    >
      <template v-slot:prepend>
        <v-icon v-if="!item.addForbidden && clifor" class="ml-2" color="info" @click="onModificaClifor" title="Modifica cliente/fornitore">mdi-pencil</v-icon>        
      </template>    
      <template v-slot:append-outer>
        <v-icon v-if="!item.addForbidden" class="mr-2" color="success" @click="onNuovoClifor" title="Crea un nuovo cliente/fornitore">mdi-account-plus-outline</v-icon>
      </template>
    </v-autocomplete>
    <modale-clienti :mostraModale="mostraModale" :clifor="modaleCliente" @save="onSaveCliente"/>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import ModaleClienti from '@/views/clienti/modaleClienti'
  import clienti from '@/services/clientiService.js'
  import movimenti from '@/services/movimentiService.js'

  export default {
    name: 'clifor',
    components: {
      ModaleClienti
    },
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      index: Number,
      updateTrigger: Number,
      soloPlaceholder: { type: Boolean, default: false },
      // prodotto: { type: String, default: '' }
      prodotto: Object,
      backColor: { type: String, default: 'transparent' }
    },
    data (vm) {
      return {
        loading: false,
        items: [],
        debounceSearch: null,
        searchClifor: '',
        clifor: null,
        selectFirst: true,
        newItem: null,
        primaChiamata: false,
        mostraModale: false,
        modaleCliente: null,
        nuovoCliente: false,
        fornitori: [],
        prezzoMinimo: 0,
        prezzoMassimo: 0,
      // TODO: Parametrizzare la scelta del prezzo sul fornitore: il minimo, il massimo, l'ultimo
        tipoPrezzo: 'ultimo'      
      }
    },
    created() {
      this.debounceSearch = _.debounce(this.searchCliforDeb, 500)
    },
    async mounted() {
      if (this.item && this.item.value) {
        const cliente = await this.queryCodiceCliente(this.item.value.codice)
        this.items = [cliente]
        this.clifor = cliente
        this.primaChiamata = true
      }
    },
    watch: {
      async searchClifor(val) {
        if (val && !this.primaChiamata) {
          await this.debounceSearch(val)
        }
        this.primaChiamata = false
      },
      async locProdotto(val) {
        console.log('locProdotto', val)
        if (val) {
          await this.elaboraFornitori()
        }
      }
    },
    computed: {
      locProdotto() {
        return (this.prodotto && this.prodotto.codice) || ''
      },
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      localDisabled() {
        if (!this.item || !this.appoggio) {
          return true
        }
        const pf = this.item.model === 'prodotto.fornitore'
        if (pf) return false
        const cl = this.item.model === 'anagrafica.cliente'
        const fr = this.item.model === 'anagrafica.fornitore'        
        const vc = this.appoggio.clienteVisibile
        const vf = this.appoggio.fornitoreVisibile
        return cl && vf || fr && vc || (!cl && !fr)
      }
/*       isNewClifor() {
        console.log('isNewClifor', this.$store.getters['clienti/creaClifor'])
        return this.$store.getters['clienti/creaClifor']
      },
      isEditClifor() {
        console.log('isEditClifor', this.$store.getters['clienti/editClifor'])
        return this.$store.getters['clienti/editClifor']
      } */
    },
    methods: {
      async elaboraFornitori() {
        if (!this.locProdotto) return
        const mm = await movimenti.getMovimentiProdottoTipoCliente(this.locProdotto, null, 'acquisto')
        const fornitori = []
        const menu = []
        for (let m of _.sortBy(mm.rows, 'data').reverse()) {
          const codFor = _.get(m, 'anagrafica.fornitore.codice', '')
          const prezzo = +((m.valore || 0) / m.quantita).toFixed(2)
          let esistente = fornitori.find(x => x.fornitore && x.fornitore.codice === codFor)
          const idx = fornitori.indexOf(esistente)
          if (prezzo > 0 && ((prezzo < this.prezzoMinimo && this.tipoPrezzo === 'minimo' ) || this.prezzoMinimo === 0)) {
            this.prezzoMinimo = prezzo
            if (esistente) {
              fornitori[idx].prezzo = prezzo
              fornitori[idx].data = m.data
              fornitori[idx].quantita = m.quantita
            }
          }
          if (prezzo > 0 && ((prezzo > this.prezzoMassimo && this.tipoPrezzo === 'massimo') || this.prezzoMassimo === 0)) {
            this.prezzoMassimo = prezzo
            if (esistente) {
              fornitori[idx].prezzo = prezzo
              fornitori[idx].data = m.data
              fornitori[idx].quantita = m.quantita
            }
          }
          if (!esistente) {
            const riga = {
              fornitore: m.anagrafica.fornitore,
              quantita: m.quantita,
              prezzo: +(m.valore / m.quantita).toFixed(2),
              data: m.data
            }
            fornitori.push(riga)
          }
        }
        for (let f of fornitori) {
          const cliente = await clienti.getCliente(f.fornitore.codice)
          const item = { 
            // testo: `${cliente.codice} - ${cliente.ragioneSociale} | Acquisto: ${this.$options.filters.euro(riga.prezzo)} il ${this.$options.filters.date(riga.data)}}`,
            testo: `${cliente.ragioneSociale} | Acquisto: ${this.$options.filters.euro(f.prezzo)} (${this.$options.filters.date(f.data)})`,
            id: cliente._id,
            codice: cliente.codice,
            descrizione: cliente.ragioneSociale,
            cliente: cliente.amministrativi.cliente,
            fornitore: cliente.amministrativi.fornitore,
            prezzo: f.prezzo
          }
          menu.push(item)
          this.clifor = cliente
        }        
        this.fornitori = fornitori
        this.items = menu
        this.primaChiamata = true
      },
      async acquistoFornitore(fornitore) {
        if (!this.locProdotto) return
        const mm = await movimenti.getMovimentiProdottoTipoCliente(this.locProdotto, null, 'acquisto')
        var acquisto
        const menu = []
        for (let m of _.sortBy(mm.rows, 'data').reverse()) {
          const codFor = _.get(m, 'anagrafica.fornitore.codice', '')
          if (codFor !== fornitore.codice) continue
          const prezzo = +((m.valore || 0) / m.quantita).toFixed(2)
          let esistente = !!acquisto
          if (this.tipoPrezzo === 'minimo' && prezzo > 0 && (prezzo < this.prezzoMinimo || this.prezzoMinimo === 0)) {
            this.prezzoMinimo = prezzo
            if (esistente) {
              acquisto.prezzo = prezzo
              acquisto.data = m.data
              acquisto.quantita = m.quantita
            }
          }
          if (this.tipoPrezzo === 'massimo' && prezzo > 0 && (prezzo > this.prezzoMassimo || this.prezzoMassimo === 0)) {
            this.prezzoMassimo = prezzo
            if (esistente) {
              acquisto.prezzo = prezzo
              acquisto.data = m.data
              acquisto.quantita = m.quantita
            }
          }
          if (!esistente) {
            acquisto = {
              fornitore: m.anagrafica.fornitore,
              quantita: m.quantita,
              prezzo: +(m.valore / m.quantita).toFixed(2),
              data: m.data
            }
          }
        }
        if (!acquisto) {
          return {
            testo: `${fornitore.ragioneSociale} | Acquisto: ---`,
            id: fornitore._id,
            codice: fornitore.codice,
            descrizione: fornitore.ragioneSociale,
            cliente: fornitore.amministrativi.cliente,
            fornitore: fornitore.amministrativi.fornitore          
          }
        }
        const f = acquisto
        const cliente = await clienti.getCliente(f.fornitore.codice)
        const item = { 
          // testo: `${cliente.codice} - ${cliente.ragioneSociale} | Acquisto: ${this.$options.filters.euro(riga.prezzo)} il ${this.$options.filters.date(riga.data)}}`,
          testo: `${cliente.ragioneSociale} | Acquisto: ${this.$options.filters.euro(f.prezzo)} il ${this.$options.filters.date(f.data)}}`,
          id: cliente._id,
          codice: cliente.codice,
          descrizione: cliente.ragioneSociale,
          cliente: cliente.amministrativi.cliente,
          fornitore: cliente.amministrativi.fornitore,
          prezzo: f.prezzo
        }    
        return item
      },
      async searchCliforDeb(val) {
        // TODO: verificare se quello cercato è già presente prima di richiamare
        // const pr = this.prodottiSelezionati.filter(x => x === val)
        // if (val && pr.length === 0) {
        if (val) {
          await this.querySelections(val)
        }
      },
      async querySelections (val) {
        if (val.indexOf('Acquisto:') > 0) {
          console.log('uscito per valore', val)
          return
        }
        this.loading = true
        const filtri = {
          testo: val,
          isCliente: this.appoggio.clienteVisibile,
          isFornitore: this.appoggio.fornitoreVisibile
        }
        // const data = await clienti.getFilteredCustomers(filtri, null, 'v3')
        const data = await clienti.getFilterByDescription(filtri, null, 'v3')
        
        const cp = data && data.total_rows > 0 ? data.rows : []

        const items = []
        for (let c of cp) {
          const itm = await this.acquistoFornitore(c)
          items.push(itm)
        }
        this.items = items
/*         this.items = cp.map(x => {
          return { 
            // testo: `${x.codice} - ${x.ragioneSociale} ${x.amministrativi && x.amministrativi.partitaIva || ''}`,
            // testo: `${x.codice} - ${x.ragioneSociale} | Acquisto: ---`,
            testo: `${x.ragioneSociale} | Acquisto: ---`, // TODO: Cercare eventuali acquisti
            id: x._id,
            codice: x.codice,
            descrizione: x.ragioneSociale,
            cliente: x.amministrativi.cliente,
            fornitore: x.amministrativi.fornitore
            }
        }) */
        this.loading = false
      },
      async queryCodiceCliente(codice) {
        this.loading = true
        const cliente = await clienti.getCliente(codice)
        this.loading = false
        return await this.acquistoFornitore(cliente)
/*         return { 
          // testo: `${cliente.codice} - ${cliente.ragioneSociale} ${cliente.amministrativi && cliente.amministrativi.partitaIva || ''}`,
          testo: `${cliente.ragioneSociale} ${cliente.amministrativi && cliente.amministrativi.partitaIva || ''}`,
          id: cliente._id,
          codice: cliente.codice,
          descrizione: cliente.ragioneSociale,
          cliente: cliente.amministrativi.cliente,
          fornitore: cliente.amministrativi.fornitore
        } */
      },
      onchange(value) {
        if (value) {
          this.searchClifor = ''
          const clifor = {
            codice: this.clifor.codice, //this.item.value.codice || this.item.value.id,
            descrizione: this.clifor.descrizione, // this.item.value.descrizione
            items: this.items,
            prezzo: this.clifor.prezzo,
            testo: this.clifor.testo,
            minimo: this.prezzoMinimo,
            massimo: this.prezzoMassimo
          }
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: clifor, item: this.item.value, index: this.index })
        }
      },
      async onNuovoClifor() {
        this.modaleCliente = await clienti.getModello()
        this.nuovoCliente = true
        this.mostraModale = true
        await this.$nextTick()
        this.mostraModale = false
      },
      async onModificaClifor() {
        this.modaleCliente = JSON.parse(JSON.stringify(this.clifor))
        this.mostraModale = true
        await this.$nextTick()
        this.mostraModale = false
      },
      async onSaveCliente(cliente) {
        await this.querySelections(cliente._id)
        if (this.nuovoCliente) {
          this.clifor = this.items[0]
          this.onchange(true)
          this.nuovoCliente = false
        }
      }
    }
  }
</script>

<style>
  .v-navigation-drawer--temporary {
    z-index: 999;
  }
</style>